import { render, staticRenderFns } from "./avatar.vue?vue&type=template&id=5d2536e9"
import script from "./avatar.vue?vue&type=script&lang=js"
export * from "./avatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gobo-app/gobo-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d2536e9')) {
      api.createRecord('5d2536e9', component.options)
    } else {
      api.reload('5d2536e9', component.options)
    }
    module.hot.accept("./avatar.vue?vue&type=template&id=5d2536e9", function () {
      api.rerender('5d2536e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/avatar.vue"
export default component.exports